import { apiClient } from "../../../shared/api/client";
import { TRANSACTION_ENDPOINTS } from "./endpoints";

export const getSingleTransaction = async (id: string) => {
  const endpoint = TRANSACTION_ENDPOINTS.SINGLE_TRANSACTION(id);
  const response = await apiClient.get(endpoint);
  return response.data;
};

